const SECTION_6_DEFAULT = `Le site s'appuie sur les infrastructures d'Emergent pour l'application et le stockage, et sur IONOS pour la messagerie. MAINGUY IMMOBILIER veille à ce que l'ensemble de ses sous-traitants respectent les exigences du RGPD. En cas de transfert hors EEE, des garanties appropriées (décisions d'adéquation, Clauses Contractuelles Types) sont appliquées.`;

const section6EU = (s) => {
  const provider = (s.hosting_provider || "").trim();
  const location = (s.hosting_location || "").trim();
  const database = (s.hosting_database || "").trim();
  const server = provider || location ? ` (serveur ${[provider, location].filter(Boolean).join(" – ")})` : "";
  const db = database ? ` La base de données est opérée par ${database}, également située dans l'Union européenne.` : "";
  return `Le site, sa base de données et les fichiers déposés par les utilisateurs sont hébergés exclusivement dans l'Union européenne${server}.${db} La messagerie professionnelle de l'agence est opérée par IONOS SE (Union européenne). Aucun transfert de données personnelles hors de l'Espace économique européen n'est réalisé. MAINGUY IMMOBILIER s'assure que l'ensemble de ses sous-traitants présentent des garanties conformes à l'article 28 du RGPD.`;
};

const policyText = ({ section6, cloudflare }) => `Dernière mise à jour : 13 octobre 2026

La société MAINGUY IMMOBILIER accorde une importance particulière à la protection des données personnelles des utilisateurs de son site internet et des personnes qui font appel à ses services.
La présente politique explique quelles données personnelles sont collectées, pourquoi elles le sont, comment elles sont utilisées, combien de temps elles sont conservées et quels sont les droits des personnes concernées.

1. Responsable du traitement
Le responsable du traitement des données personnelles est :
MAINGUY IMMOBILIER
Forme juridique : Société par actions simplifiée (SAS)
Adresse du siège social : 65 impasse des Tonneliers, 44430 Le Loroux-Bottereau
SIREN : 109 512 798
SIRET : 109 512 798 00017
Téléphone : 06 32 03 60 38
Adresse électronique : contact@mainguy-immobilier.fr
Site internet : https://mainguy-immobilier.fr
Pour toute question relative à la présente politique ou au traitement des données personnelles, vous pouvez contacter l'agence à l'adresse électronique indiquée ci-dessus.

2. Données personnelles collectées
Les données collectées dépendent du formulaire utilisé et de la relation entretenue avec MAINGUY IMMOBILIER.

2.1. Formulaire de contact
Lorsqu'un utilisateur contacte l'agence par l'intermédiaire du site, les données suivantes peuvent être collectées : nom et prénom ; adresse électronique ; numéro de téléphone ; objet de la demande ; contenu du message.

2.2. Formulaire d'estimation immobilière
Lorsqu'un utilisateur demande une estimation de son bien, les données suivantes peuvent être collectées : nom et prénom ; adresse électronique ; numéro de téléphone ; adresse du bien à estimer ; commentaires ou informations complémentaires.

2.3. Formulaire de gestion locative
Lorsqu'un propriétaire sollicite l'agence pour la gestion de son bien, les données suivantes peuvent être collectées : nom et prénom ; adresse électronique ; numéro de téléphone ; type de bien ; commune du bien ; description et informations complémentaires.

2.4. Dépôt d'un dossier de candidature à la location
Lorsqu'un candidat transmet un dossier locatif par l'intermédiaire du site, les données suivantes peuvent être collectées : nom et prénom ; adresse électronique ; numéro de téléphone ; référence du bien concerné ; type de document transmis ; documents justificatifs transmis au format PDF.
Les documents sont traités exclusivement dans le cadre de l'étude des candidatures locatives.

2.5. Données relatives aux biens et aux clients
Dans le cadre de ses activités immobilières, MAINGUY IMMOBILIER traite les informations nécessaires à la vente, à la location, à la gestion d'un bien et au suivi des relations contractuelles.

2.6. Données techniques
Des données techniques nécessaires au fonctionnement et à la sécurité du site (requêtes, erreurs, journaux de sécurité) peuvent être traitées.

3. Finalités et bases légales des traitements
• Répondre aux demandes de contact (mesures précontractuelles / intérêt légitime)
• Étudier une demande d'estimation ou de gestion locative (mesures précontractuelles)
• Examiner une candidature locative (mesures précontractuelles / intérêt légitime)
• Gérer les relations contractuelles clients (exécution du contrat / obligations légales)
• Assurer la sécurité et le fonctionnement du site (intérêt légitime / obligations légales)

4. Caractère obligatoire ou facultatif des données
Les champs obligatoires sont nécessaires au traitement de la demande. Les champs facultatifs permettent de compléter le dossier.

5. Destinataires des données
Les données sont uniquement accessibles aux personnes habilitées au sein de MAINGUY IMMOBILIER et à ses prestataires techniques (hébergement, stockage sécurisé, messagerie professionnelle IONOS). Elles ne sont en aucun cas vendues à des tiers.

6. Hébergement et transferts de données
${section6}

7. Durées de conservation
• Demandes de contact, estimation, gestion : 3 ans à compter du dernier contact.
• Candidatures locatives non retenues : suppression automatique sous 90 jours.
• Candidatures locatives approuvées (devenues locataires) : intégrées au dossier de gestion, conservées pendant toute la durée du bail puis archivées selon les délais de prescription légale applicables (3 à 5 ans) avant suppression.
• Documents contractuels et comptables : archivés selon les obligations légales (jusqu'à 10 ans).

8. Suppression automatique des données du site
Un mécanisme automatisé quotidien (à 3 h 30, heure de Paris) purge les demandes de contact/estimation/gestion de plus de 3 ans et les dossiers candidats non retenus de plus de 90 jours. Les dossiers approuvés ne sont pas inclus dans cette purge afin de respecter le suivi contractuel et légal.

9. Sécurité des données
Les mesures incluent : l'accès restreint à l'Espace Pro par authentification sécurisée par identifiant et mot de passe, le chiffrement HTTPS (TLS), le hachage des mots de passe, et le contrôle d'accès strict aux pièces justificatives des locataires.

10. Cookies, traceurs et services tiers
Aucun outil de suivi comportemental ou publicitaire (type PostHog) n'est actif sur le site public. Seuls des cookies/traceurs strictement techniques et essentiels à la sécurité${cloudflare} peuvent être déposés sans consentement préalable requis.

11. Droits des personnes concernées
Vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données. Exercice des droits par e-mail : contact@mainguy-immobilier.fr. Vous pouvez également introduire une réclamation auprès de la CNIL (cnil.fr).

12. Données concernant les mineurs
Les services s'adressent aux personnes majeures. Toute donnée relative à un mineur est traitée sous la responsabilité de son représentant légal.

13. Contact
MAINGUY IMMOBILIER – 65 impasse des Tonneliers, 44430 Le Loroux-Bottereau
Tél. : 06 32 03 60 38 – E-mail : contact@mainguy-immobilier.fr`;

export const buildPrivacyPolicy = (settings = {}) =>
  policyText({
    section6: settings.hosting_eu ? section6EU(settings) : SECTION_6_DEFAULT,
    cloudflare: settings.hosting_eu ? "" : " (ex. Cloudflare)",
  });

export const PRIVACY_POLICY = buildPrivacyPolicy();
